import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../ui/index.js';

// INVARIANT: this component MUST NOT receive `RequestView` or
// `requestQuery` and MUST NOT import `RequestView` types. The warm-cache
// 404 leak (react-query retains `data` after a failed refetch — the
// user is no longer authorized to see it but the cache still holds it)
// is closed by construction: there is no symbol the component can reach
// to render `r.name`, `MetaRow`, tabs, sticky bar, chat, audit, or
// items. `requestId` is sourced from the URL — user input, not server
// data — so rendering it does not risk the warm-path leak.
export function RequestDrawerUnavailableStub({
  requestId,
  onClose,
}: {
  requestId: string;
  onClose: () => void;
}) {
  const { t } = useTranslation(['requests', 'common']);
  return (
    <div
      data-testid="request-drawer-unavailable"
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: 'var(--bg-1)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 16px' }}>
        <IconButton icon="x" label={t('common:actions.close')} onClick={onClose} />
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          padding: '0 24px',
        }}
      >
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: 'var(--fg-1)' }}>
          {t('requests:unavailable.title')}
        </h2>
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 12,
            color: 'var(--fg-3)',
          }}
        >
          {requestId}
        </span>
      </div>
    </div>
  );
}
